import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-se",
  "use": "icon-icon-se-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-se\">\n  <path fill=\"#005293\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#fecb00\" d=\"M134 0v204.8H0v102.4h134V512h102.4V307.2H512V204.8H236.4V0H134z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol